import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 7D3932BA-9061-40D7-B624-044EE7A7B445
 * name image-filter-black-white
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/image-filter-black-white.svg
 * tags
 * - Photography 
 */
export const ImageFilterBlackWhiteIcon = createSvgIcon(<><path d="M19,19L12,11V19H5L12,11V5H19M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z" /></>, 'ImageFilterBlackWhiteIcon');
export default ImageFilterBlackWhiteIcon